/*
 * Project: bellcloud
 * File: packages/theme/tokens/border.ts
 * Description: Border width tokens based on Bellcloud Design System
 */

export type BorderTokens = {
  s: number;
  md: number;
  lg: number;
  xl: number;
};

export const border: BorderTokens = {
  s: 0.5,
  md: 1,
  lg: 1.5,
  xl: 2,
};
